import React, { useEffect, useState } from 'react'
import styles from './AppModal.module.css'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { BASE_URL } from '../../../Apis/BaseUrl';
import axios from 'axios';
import { fileChecker } from '../../../Component/FileChecker/fileChecker';
import Cookies from 'js-cookie';
import { Form } from 'react-bootstrap';

const UpdatePlace = ({ isOpen, closeModal, getData , data }) => {
    const [heading, setHeading] = useState('')
    const [loading, setLoading] = useState(false)


    let profileTokenJson = Cookies.get("v&b_token");
    let profileToken = JSON.parse(profileTokenJson);
    let token = profileToken.token;

    const handleDataUpload = async () => {
        const formData = new FormData();
        formData.append('name', heading);

        const register = `${BASE_URL}/visualizer/place/${data?._id}/edit`

        const myToast = toast.loading('Please Wait...')
        setLoading(true)
        try {
            const response = await axios.put(register, formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data',
                },
            })

            if (!response.data.success) {
                throw new Error(response.data.message)

            }
            toast.update(myToast, {
                render: response.data.message,
                type: 'success',
                isLoading: false,
                autoClose: 1500
            });
            getData()
            setHeading('')
        } catch (error) {
            console.error('Error while uploading data:', error);

            toast.update(myToast, {
                render: error.message,
                type: 'error',
                isLoading: false,
                autoClose: 1500
            });
        }
        finally {
            closeModal()

            setLoading(false)
        }
    };

    useEffect(()=>{
        setHeading(data?.name)
    },[])

    return (
        <React.Fragment>
            <Modal show={isOpen} onHide={closeModal}>
                <Modal.Header>
                    <Modal.Title className={styles.modal_title}>Update Place</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mb-3'>
                    <div className='mx-auto' md={9}>
                        <div className={styles.main_section}>
                            <Form>
                                <div className={styles.main_div}>
                                    <label htmlFor="">Name</label>
                                    <input type="text" value={heading} onChange={(e) => setHeading(e.target.value)} />
                                </div>
                            </Form>
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <div className={styles.model_button}>
                        <button className='bg-white text-black border' variant="secondary" onClick={closeModal}> Cancel  </button>
                        <button disabled={loading} variant="primary" onClick={handleDataUpload}>{loading ? 'Loading' : 'Update Place'}</button>
                    </div>

                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default UpdatePlace